import config from './config';

let authToken = null;

export const setAuthToken = (token) => { authToken = token; };

const headers = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'secret-key': config.SECRET_KEY,
  'build-version': config.VERSION,
  ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
});

const post = async (endpoint, body) => {
  const res = await fetch(`${config.API_URL}${endpoint}`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(body),
  });
  return res.json();
};

const get = async (endpoint) => {
  const res = await fetch(`${config.API_URL}${endpoint}`, {
    method: 'GET',
    headers: headers(),
  });
  return res.json();
};

export const getOrganizations = () => post('/organizations', {});

export const confirmCourier = (code, pincode, organizationId) =>
  post('/login', { code, pincode, organizationIds: [organizationId] });

export const getDeliveries = () => get('/deliveries/today');

export const getDeliveryById = (orderId) =>
  post('/get_delivery_by_id', { orderIds: [orderId] });

export const updateDeliveryStatus = (orderId, deliveryStatus) =>
  post('/deliveries/status', { orderId, deliveryStatus });

export const getDeliveredHistory = () => get('/deliveries/history');

export const getEmployeeInfo = () => get('/employees/info');
